import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../component/SEO';
import './NotFound.css';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="test_block">
      <SEO
        title={`404 - ${t('notFound.title')} | ${t('seo.defaultTitle')}`}
        description={t('notFound.description')}
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
            <div className="not-found-container">
              <h1 className="not-found-title">404</h1>
              <h2 className="not-found-subtitle">{t('notFound.title')}</h2>
              <p className="not-found-text">{t('notFound.description')}</p>
              <div className="not-found-actions">
                <Link to="/" className="btn btn-primary">{t('notFound.backToHome')}</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
